module.exports = __webpack_public_path__ + "fonts/Lato-300-latin4.716309a.woff2";